module.exports = __webpack_public_path__ + "img/图片8.ec7d5f88.png";